import _ from 'lodash';
import * as IntegrationsApi from './IntegrationsApi';
import IntegrationsConstants from './IntegrationsConstants';

const receivedIntegration = (integration) => ({
    type: IntegrationsConstants.INTEGRATION_RECEIVED,
    payload: {
        id: integration.id,
        type: integration.type,
        name: integration.name,
        about: integration.about,
        link: integration.link,
        picture: integration.picture,
        disconnected_at: integration.disconnected_at,
    }
});

export function listIntegrations(accountId) {
    return function (dispatch) {
        return IntegrationsApi.listIntegrations(accountId).then(response => {
            _.map(response, integration => {
                dispatch(receivedIntegration(integration));
            });

            return response;
        });
    };
}

const removedIntegration = (integrationId) => ({
    type: IntegrationsConstants.INTEGRATION_REMOVED,
    payload: {
        id: integrationId,
    }
});

export function removeIntegration(integrationId) {
    return function (dispatch, getState) {
        dispatch(removedIntegration(integrationId));

        return IntegrationsApi.removeIntegration(integrationId);
    }
}